// The sounds of the Inbox alerts and their volume (pure data and arithmetic: alerts.js plays them).
// Each tone: notes [frequency Hz, start s], how long each note rings (s), the wave, and the overtones [multiple of the frequency, loudness].

export const TONES = {
  classic: { name: 'Classic', notes: [[660, 0], [880, 0.15], [1320, 0.3]], len: 0.28, wave: 'sine', partials: [[1, 1]] }, // the sound this always was
  chime: { name: 'Chime', notes: [[784, 0], [988, 0.18], [1175, 0.36], [1568, 0.54]], len: 0.55, wave: 'sine', partials: [[1, 1], [2, 0.3]] },
  bell: { name: 'Bell', notes: [[880, 0], [880, 0.9]], len: 1.3, wave: 'sine', partials: [[1, 1], [2.76, 0.5], [5.4, 0.25], [8.9, 0.1]] },
  ping: { name: 'Ping', notes: [[1760, 0], [1760, 0.14], [1760, 0.28]], len: 0.12, wave: 'triangle', partials: [[1, 1]] },
  double: { name: 'Double ring', notes: [[880, 0], [660, 0.18], [880, 0.6], [660, 0.78]], len: 0.2, wave: 'triangle', partials: [[1, 1], [2, 0.2]] },
  alarm: { name: 'Alarm (loudest)', notes: [[1000, 0], [1000, 0.2], [1000, 0.4], [1000, 0.6]], len: 0.12, wave: 'square', partials: [[1, 0.6]] },
};

export const DEFAULT_TONE = 'classic';
export const DEFAULT_VOLUME = 85; // 0-100. Louder than the first versions (about twice as loud), which people found faint.

/** A saved tone name, or the default when it isn't one we know. */
export const toneOf = (id) => (Object.hasOwn(TONES, id) ? id : DEFAULT_TONE);

/** The tone for tickets: 'same' (as for chats) or one of the tones. */
export const ticketToneOf = (id) => (id === 'same' || Object.hasOwn(TONES, id) ? id : 'same');

/** The volume as 0-100 (anything else: the default). */
export function volumeOf(v) {
  const n = v === null || v === '' ? NaN : Number(v);
  return Number.isFinite(n) ? Math.min(100, Math.max(0, Math.round(n))) : DEFAULT_VOLUME;
}

/** The gain for a volume: it falls faster than the slider, as loudness is felt (0 is silent, 100 is the loudest the speakers do). */
export const gainOf = (volume) => (volumeOf(volume) / 100) ** 2;

/** Which tone plays: kind 'ticket' may have its own; otherwise the chat tone. */
export function toneFor(prefs, kind = 'chat') {
  const ticket = ticketToneOf(prefs.ticketTone);
  return kind === 'ticket' && ticket !== 'same' ? ticket : toneOf(prefs.tone);
}
